/**
 * Customer-site presentation overrides for substrate-generated group titles.
 *
 * Substrate's _SECTION_TITLES dict (scripts/gen_schema_artifacts.py:110-119)
 * is the source of truth for the internal taxonomy; renaming there would
 * propagate to the internal everest-docs site too. This module is the
 * customer-only override layer for henoyo-docs.
 *
 * Three call sites apply these overrides — all three must stay in sync, which
 * is the reason this module exists rather than duplicated dicts:
 *   - src/config/manifest.ts (SPA merge — HomePage, DocHeader, DocBreadcrumb, DocSidebar)
 *   - src/search/buildIndex.ts (search index build — SearchModal)
 *   - content/build.ts (defense-in-depth; group.title not currently baked into
 *     rendered HTML, but applying here keeps the override at parity if a
 *     future render path adds it)
 *
 * Filed by substrate#269 (rename schema-ai-orchestration → "AI Orchestration Platform"
 * on the customer site only).
 */
export const GROUP_TITLE_OVERRIDES = {
  'schema-ai-orchestration': 'AI Orchestration Platform',
} as const;

export function applyGroupTitleOverrides<G extends { id: string; title: string }>(
  groups: G[],
): G[] {
  return groups.map((g) =>
    g.id in GROUP_TITLE_OVERRIDES
      ? { ...g, title: GROUP_TITLE_OVERRIDES[g.id as keyof typeof GROUP_TITLE_OVERRIDES] }
      : g,
  );
}
